import React, { useEffect, useState } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { jsonp } from '@ifeng-fe/ui_base';
import styles from './index.css';
import classNames from 'classnames/bind';
import { getAwardList } from '@src/services/api';

const cx = classNames.bind(styles);

const Modal = () => {

    const [modalList, setModalList] = useState([]);

    const fetchData = async () => {
        const data = await getAwardList();

        if (data.code === 0) {
            setModalList(data.data.content.slice(0, 7));
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className={styles.awards}>
            <div className={styles.modalHeader}>
                <a href="https://sports.ifeng.com/loc/special/olympicfrance/awards" target="_blank" className={styles.href} rel="noreferrer">全部榜单 <img src="https://x0.ifengimg.com/ucms/2022_03/752418662FA3AA31AA4ECAB4A5E5690BD8159DA4_size0_w16_h16.png" alt="" /></a>
            </div>
            <div className={styles.tableWp}>
                <table frame="void" className={styles.modalTable}>
                    <tbody>
                        <tr>
                            <th>排名</th>
                            <th className={styles.area}>国家/地区</th>
                            <th className={styles.imgTh}><img src="https://x0.ifengimg.com/ucms/2022_03/17E50ECABF7880EC63EB03B039E86E80FF8D77C4_size4_w60_h80.png" alt="金牌" /></th>
                            <th className={styles.imgTh}><img src="https://x0.ifengimg.com/ucms/2022_03/EDE090D64A6887185E563B29261EB42415C91BEB_size4_w60_h80.png" alt="银牌" /></th>
                            <th className={styles.imgTh}><img src="https://x0.ifengimg.com/ucms/2022_03/AF9CE8947D422028BCAB5E81710D2D0EE2EFA1C3_size5_w60_h80.png" alt="铜牌" /></th>
                            <th>总数</th>
                        </tr>
                        {
                            modalList.map((modal, index) => {
                                return (
                                    <tr key={index} className={index % 2 === 0 ? `${styles.first}` : `${styles.second}`}>
                                        <td className={cx('num', { first: index === 0, second: index === 1, third: index === 2 })}>{index + 1}</td>
                                        <td className={styles.area}><img src={modal.img} alt={modal.country} />{modal.country}</td>
                                        <td className={styles.imgTh}>{modal.gold}</td>
                                        <td className={styles.imgTh}>{modal.silver}</td>
                                        <td className={styles.imgTh}>{modal.copper}</td>
                                        <td>{modal.sum}</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default errorBoundary(Modal);
